var _rect, _circle, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLicenseAllocationUpgrade(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12231_41698)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    fill: "#FDFDFD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108.4,
    cy: 108.799,
    r: 104,
    fill: "#ECEEF5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12231_41698",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -13,
    y: 9,
    width: 227,
    height: 207
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M208.801 129.2C201.379 155.765 190.522 173.936 166.916 190.793C165.791 191.596 164.514 192.171 163.172 192.507L74.1476 214.763C72.9904 215.052 71.7951 215.159 70.605 215.079L11.703 211.128C8.57311 210.918 5.66653 209.433 3.66238 207.02L-9.9066 190.682C-11.7648 188.445 -12.7017 185.584 -12.5271 182.681L-2.74113 19.9439C-2.34076 13.2858 3.64415 8.37861 10.2515 9.29074L115.066 23.7601C116.216 23.9188 117.384 23.9017 118.529 23.7094L200.243 9.97868C207.492 8.76051 214 14.5818 213.636 21.924C211.46 65.7435 209.728 125.882 208.801 129.2Z",
    fill: "#ECEEF5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12231_41698)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.418247,
    y: 47.3745,
    width: 198,
    height: 157.2,
    rx: 2.6,
    transform: "rotate(-6.9559 0.418247 47.3745)",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6816 92.1426L51.2828 90.1172",
    stroke: "#D6DAE4",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9004 87.6191L40.4617 96.6662",
    stroke: "#B9BECF",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1582 97.9238L39.2052 86.3625",
    stroke: "#B9BECF",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.9531,
    y: 85.6094,
    width: 55.3631,
    height: 4.61359,
    transform: "rotate(-6.9559 73.9531 85.6094)",
    fill: "#D6DAE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.67,
    y: 74.0371,
    width: 24,
    height: 4.8,
    transform: "rotate(-6.9559 166.67 74.0371)",
    fill: "#D6DAE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8926 118.477L54.4938 116.451",
    stroke: "#D6DAE4",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1113 113.953L43.6727 123",
    stroke: "#B9BECF",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3691 124.258L42.4162 112.696",
    stroke: "#B9BECF",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.1641,
    y: 111.941,
    width: 46.1359,
    height: 4.61359,
    transform: "rotate(-6.9559 77.1641 111.941)",
    fill: "#D6DAE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.865,
    y: 100.24,
    width: 20,
    height: 4.8,
    transform: "rotate(-6.9559 169.865 100.24)",
    fill: "#D6DAE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1094 144.812L57.7106 142.787",
    stroke: "#ECEEF5",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3281 140.289L46.8894 149.336",
    stroke: "#ECEEF5",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5859 150.594L45.633 139.032",
    stroke: "#ECEEF5",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.3789,
    y: 138.277,
    width: 55.3631,
    height: 4.61359,
    transform: "rotate(-6.9559 80.3789 138.277)",
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.16,
    y: 127.242,
    width: 24,
    height: 4,
    transform: "rotate(-6.9559 173.16 127.242)",
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3203 171.143L60.9215 169.117",
    stroke: "#F9F9FB",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5391 166.619L50.1004 175.666",
    stroke: "#F9F9FB",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7969 176.924L48.8439 165.363",
    stroke: "#F9F9FB",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.5898,
    y: 164.609,
    width: 38.0621,
    height: 4.61359,
    transform: "rotate(-6.9559 83.5898 164.609)",
    fill: "#F9F9FB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.357,
    y: 153.447,
    width: 16.8,
    height: 4.8,
    transform: "rotate(-6.9559 176.357 153.447)",
    fill: "#F9F9FB"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.447,
    y: 185.795,
    width: 35.7553,
    height: 4.61359,
    transform: "rotate(-6.9559 188.447 185.795)",
    fill: "#D6DAE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.1543,
    y: 58.1406,
    width: 11.2,
    height: 8,
    transform: "rotate(-6.9559 59.1543 58.1406)",
    fill: "#D6DAE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.6836,
    y: 60.2715,
    width: 11.2,
    height: 8,
    transform: "rotate(-6.9559 41.6836 60.2715)",
    fill: "#D6DAE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.2129,
    y: 62.4023,
    width: 11.2,
    height: 8,
    transform: "rotate(-6.9559 24.2129 62.4023)",
    fill: "#D6DAE4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12231_41698"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseAllocationUpgrade);
export default __webpack_public_path__ + "static/media/LicenseAllocationUpgrade.6216ce33.svg";
export { ForwardRef as ReactComponent };